import React, { useState, useEffect } from "react";
import TeacherTableViewSearch from "../../../CustomComponent/TeacherTableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import { Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { useNavigate } from "react-router-dom";
import TeacherDetailModal from "./TeacherDetailModal";
import { decryptData } from "../../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import ReportIcon from "@material-ui/icons/Report";
import AssessmentIcon from "@material-ui/icons/Assessment";
import BarChartIcon from "@material-ui/icons/BarChart";
import DescriptionIcon from "@material-ui/icons/Description";

function ViewTeacher() {
  const classes = useStyles();
 
  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTeacherId, setSelectedTeacherId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [teachers, setTeachers] = useState([]);
  const navigate = useNavigate();

  const [pageSize, setPageSize] = useState(25);
    const [onPage, setOnPage] = useState(0);
  
    const [rowCount, setRowCount] = useState("");
  
    // const [rows, setRows] = useState([]);

      const [page, setPage] = useState(0);
      
            const handlePageChange = (newPage) => {
          setPage(newPage);
          setOnPage(newPage) // Pass newSelection directly
        };
      
  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleButtonClick = (type, rowId) => {
    if (type === "editteacher") {
      navigate(`/admin/editeacher/${rowId}`);
    }
  };

  const handleTeacherDetailsClick = (teacherId) => {
    setSelectedTeacherId(teacherId);
    setIsModalOpen(true);
    handleClose();
  };

  const fetchData = async (pageNumber, size, search) => {
          if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;

    try {
      const response = await axios.get(
        // `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/teacher`,
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/teacher?page=${pageNumber + 1}&limit=${size}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setTeachers(response.data.teachers);
      setRowCount(response.data.count);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
        if (onPage !== undefined && pageSize !== undefined && searchQuery !== undefined) {
    fetchData(onPage, pageSize, searchQuery);
        }
  }, [onPage, pageSize, searchQuery]);

  // Function to delete a book
  const deleteDataOfRow = async (rowId) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/teacher/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      fetchData(onPage, pageSize, searchQuery);
      handleClose();
      toast.success("Teacher deleted successfully");
      const updateddatatata = teachers.filter((data) => data.id !== rowId);
      setTeachers(updateddatatata);
    } catch (error) {
      toast.error("Teacher is not deleted");
    }
  };

  const handleStatus = (iddd, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    const data = {
      teacher: {
        active_status: newStatus,
        id: iddd,
      },
    };

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/teacher/status`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      )
      .then((response) => {
        fetchData(onPage, pageSize, searchQuery);
        toast.success("Teacher status changed successfully");
        handleClose();
      })
      .catch((error) => {
        toast.error("Teacher status is not changed");
      });
  };

  const rows = teachers.map((d) => ({
    id: d.id ? d.id : "N/A",
    full_name: d.full_name ? d.full_name : "N/A",
    phone: d.phone ? d.phone : "N/A",
    email: d.email ? d.email : "N/A",
    active_status: d.active_status ? d.active_status : "N/A",
  }));
  const startIndex = onPage * pageSize;

  const filteredRows = rows
    .filter((d) => {
      const isSearchMatch = d.full_name
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) || d.phone
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) || d.email
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) 

      return isSearchMatch;
    })
    .map((row, index) => ({
      ...row,
      srno: startIndex + index + 1,
    }));

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);
  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 20,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "full_name",
      headerName: "Teacher Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "email",
      headerName: "Email ID",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "phone",
      headerName: "Ph.No.",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "active_status",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 150,
      autoPageSize: false,
      renderCell: (cellValues) => {
        const isActive = cellValues.row.active_status === "active";

        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <IconButton
              className={`${classes.w15}`}
              aria-describedby={id}
              onClick={(event) => {
                handleClick(event, cellValues.row.id);
              }}
            >
              <ArrowLeftIcon fontSize="small" />
            </IconButton>
            <Typography
              className={`${classes.dflex} ${classes.alignitemscenter}  ${classes.texttransformcapitalize}`}
              variant="h6"
            >
              {isActive ? (
                <ActiveIcon className={`${classes.mr0_5}`} />
              ) : (
                <InactiveIcon fontSize="small" className={`${classes.mr0_5}`} />
              )}

              {cellValues.row.active_status}
            </Typography>
            <Popover
              id={id}
              open={popoveropen && selectedRowId === cellValues.row.id}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <Paper>
                <IconButton
                  onClick={(event) => {
                    handleStatus(
                      cellValues.row.id,
                      cellValues.row.active_status
                    );
                  }}
                >
                  <LightTooltip title="Inactive">
                    <VisibilityOffOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton
                  onClick={() => {
                    handleButtonClick("editteacher", cellValues.row.id);
                  }}
                >
                  <LightTooltip title="Edit">
                    <EditOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton>
                  <LightTooltip title="Delete">
                    <DeleteIcon
                      onClick={() => deleteDataOfRow(cellValues.row.id)}
                    />
                  </LightTooltip>
                </IconButton>

                <IconButton
                  onClick={() => handleTeacherDetailsClick(cellValues.row.id)}
                >
                  <LightTooltip title="View Details">
                    {/* <ReportIcon /> */}
                    {/* <AssessmentIcon /> */}
                    {/* <BarChartIcon /> */}
                    <DescriptionIcon />
                  </LightTooltip>
                </IconButton>
              </Paper>
            </Popover>
          </div>
        );
      },
    },
  ];

  const Heading = [
    {
      id: 1,
      // inputlable: "Enter Name / ID*",
      inputplaceholder: "Search teacher name",
      // import: "yes",
      // export: "yes",
    },
  ];

   const style = [
    {
      height: "maxh67",
      style: "viewtable",
       footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode:"server" 
    },
  ];
  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt0_5}`}
      >
        <TeacherTableViewSearch
          teacher={true}
          fetchData={fetchData}
          decryptedToken={decryptedToken}
          Heading={Heading}
          onSearch={handleSearch}
        />
        <TableView columns={columns} rows={filteredRows} Heading={style} />
      </div>

      <TeacherDetailModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        teacherId={selectedTeacherId}
      />
    </>
  );
}
export default ViewTeacher;
